import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import {
	VerifyIdentityPayload,
	VerifyIdentityResult,
} from '@/interfaces/covalynt';

class CovalyntService {
	constructor(private client: AxiosInstance) {}

	async verifyIdentity(
		body: VerifyIdentityPayload
	): Promise<HttpResponse<VerifyIdentityResult>> {
		return this.client.post('/covalynt/verify-identity', body);
	}
}

export const covalyntService = new CovalyntService(axiosClient);
